<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">
      <!--<div class="aqu-table-heading">
        <a routerLink="/BusinessEntityFarmsProvider/{{farmbusinessid}}" type="button"
           class="back_button btn btn-default btn-rounded btn-back"><i
          class="fa fa-arrow-left"></i>Back</a>
        <h4>Add Farm</h4>
      </div>-->
      <div class="row">
        <ul class="breadcrumb">
          <li><a routerLink="/home/BusinessEntityFarmsProvider/{{farmbusinessid}}">Back</a></li>
          <li><a>Add Farm</a></li>
        </ul>
      </div>
      <div class="block">
        <form [formGroup]="registerForm" (ngSubmit)="addFarmDetailsSubmit()">
          <div class="row top-field">
            <p style="font-size: 20px">Farm Details</p>
          </div>
          <div class="row top-field">
            <div class="col-xs-12 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="control-label">Farm Name</label>
                <input class="form-control" type="text" [(ngModel)]="businessEntity.businessName" formControlName="businessName"
                       [ngClass]="{ 'is-invalid': submitted && f.businessName.errors }" autocomplete="off" required
                       name="farmname"/>
                <div *ngIf="submitted && f.businessName.errors" class="invalid-feedback">
                  <div *ngIf="f.businessName.errors.required" class="alert-color">Farm Name is required.</div>
                  <div *ngIf="f.businessName.errors.minlength" class="alert-color">Minimum 3 characters.</div>
                  <div *ngIf="f.businessName.errors.maxlength" class="alert-color">Maximum 300 characters.</div>
                  <div *ngIf="f.businessName.errors.pattern" class="alert-color">Special characters not allowed.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="control-label">Business Email</label>
                <input class="form-control" type="text" [(ngModel)]="businessEntity.email" formControlName="email"
                       [ngClass]="{ 'is-invalid': submitted && f.email.errors }" autocomplete="off" required
                       name="email"/>
                <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                  <div *ngIf="f.email.errors.required" class="alert-color">Email is required.</div>
                  <div *ngIf="f.email.errors.pattern" class="alert-color">Email must be a valid email address.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row top-field">
            <div class="col-xs-12 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="control-label">Mobile Number</label>
                <input class="form-control" type="text" [(ngModel)]="businessEntity.mobileNumber"
                       formControlName="businessNumber" autocomplete="off" required
                       [ngClass]="{ 'is-invalid': submitted && f.businessNumber.errors }"
                       name="businessnumber"/>
                <div *ngIf="submitted && f.businessNumber.errors" class="invalid-feedback">
                  <div *ngIf="f.businessNumber.errors.required" class="alert-color">Mobile number is required.</div>
                  <div *ngIf="f.businessNumber.errors.pattern" class="alert-color">Invalid Mobile number.</div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="control-label">CAA ID</label>
                <input class="form-control" type="text" name="caaid" formControlName="caaid" autocomplete="off"
                       [(ngModel)]="businessEntity.CAA_ID"
                       [ngClass]="{ 'is-invalid': submitted && f.caaid.errors }">
                <div *ngIf="submitted && f.caaid.errors" class="invalid-feedback">
                  <div *ngIf="f.caaid.errors.maxlength" class="alert-color">Maximum 16 characters.</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row top-field">
            <div class="col-xs-12 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="control-label">MPEDA ID</label>
                <input class="form-control" type="text" name="mpedaid" formControlName="mpedaid"
                       autocomplete="off" [(ngModel)]="businessEntity.MPEDA_ID"
                       [ngClass]="{ 'is-invalid': submitted && f.mpedaid.errors }">
                <div *ngIf="submitted && f.mpedaid.errors" class="invalid-feedback">
                  <div *ngIf="f.mpedaid.errors.maxlength" class="alert-color">Maximum 16 characters.</div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="control-label">Valid Through</label>
                <input type="text" name="validthrough" formControlName="validThrough"
                       [(ngModel)]="businessEntity.validThrough" autocomplete="off"
                       class="form-control select validthrough" placeholder="DD-MM-YYYY">
                <span class="caret history-caret"></span>
              </div>
            </div>
          </div>
          <div class="row top-field">
            <div class="col-xs-12 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="control-label">Address Line1</label>
                <input class="form-control" type="text" name="hno" formControlName="inputhouseNo"
                       [ngClass]="{ 'is-invalid': submitted && f.businessNumber.errors }" autocomplete="off"
                       required
                       [(ngModel)]="address.houseNo"/>
                <div *ngIf="submitted && f.inputhouseNo.errors" class="invalid-feedback">
                  <div *ngIf="f.inputhouseNo.errors.required" class="alert-color">Address line1 is
                    required.
                  </div>
                  <div *ngIf="f.inputhouseNo.errors.pattern" class="alert-color">Enter valid H.No/Flat.No/Suite
                    No.
                  </div>
                  <div *ngIf="f.inputhouseNo.errors.minlength" class="alert-color">Minimum 3 characters.</div>
                  <div *ngIf="f.inputhouseNo.errors.maxlength" class="alert-color">Maximum 30 characters.</div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="control-label">Address Line2</label>
                <input class="form-control" type="text" name="street" formControlName="inputstreet"
                       [ngClass]="{ 'is-invalid': submitted && f.inputstreet.errors }" autocomplete="off" required
                       [(ngModel)]="address.street"/>
                <div *ngIf="submitted && f.inputstreet.errors" class="invalid-feedback">
                  <div *ngIf="f.inputstreet.errors.required" class="alert-color">Address line2 is
                    required.
                  </div>
                  <div *ngIf="f.inputstreet.errors.pattern" class="alert-color">Enter valid street/Road
                    name/Building name.
                  </div>
                  <div *ngIf="f.inputstreet.errors.minlength" class="alert-color">Minimum 3 characters.</div>
                  <div *ngIf="f.inputstreet.errors.maxlength" class="alert-color">Maximum 50 characters.</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row top-field">
            <div class="col-xs-12 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="control-label">City/Town</label>
                <input class="form-control" type="text" name="city" formControlName="inputcity"
                       [ngClass]="{ 'is-invalid': submitted && f.inputcity.errors }" autocomplete="off" required
                       [(ngModel)]="address.city"/>
                <div *ngIf="submitted && f.inputcity.errors" class="invalid-feedback">
                  <div *ngIf="f.inputcity.errors.required" class="alert-color">City/Town is required.</div>
                  <div *ngIf="f.inputcity.errors.pattern" class="alert-color">Enter valid City/Town name.</div>
                  <div *ngIf="f.inputcity.errors.minlength" class="alert-color">Minimum 3 characters.</div>
                  <div *ngIf="f.inputcity.errors.maxlength" class="alert-color">Maximum 300 characters.</div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="control-label">Pincode</label>
                <input class="form-control" type="text" name="pincode" formControlName="inputpincode"
                       [ngClass]="{ 'is-invalid': submitted && f.inputpincode.errors }" autocomplete="off" required
                       [(ngModel)]="address.pincode"/>
                <div *ngIf="submitted && f.inputpincode.errors" class="invalid-feedback">
                  <div *ngIf="f.inputpincode.errors.required" class="alert-color">Pincode is required.</div>
                  <div *ngIf="f.inputpincode.errors.minlength" class="alert-color">Minimum 6 characters.</div>
                  <div *ngIf="f.inputpincode.errors.maxlength" class="alert-color">Maximum 6 characters.</div>
                  <div *ngIf="f.inputpincode.errors.pattern" class="alert-color">Enter valid pincode</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row top-field">
            <div class="col-xs-12 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="control-label">District</label>
                <input class="form-control" type="text" name="updatedistrict" formControlName="inputDistrict"
                       autocomplete="off" [ngClass]="{ 'is-invalid': submitted && f.inputDistrict.errors }"
                       [(ngModel)]="address.district" required/>
                <div *ngIf="submitted && f.inputDistrict.errors" class="invalid-feedback">
                  <div *ngIf="f.inputDistrict.errors.required" class="alert-color">District is required.</div>
                  <div *ngIf="f.inputDistrict.errors.minlength" class="alert-color">Minimum 3 characters.
                  </div>
                  <div *ngIf="f.inputDistrict.errors.maxlength" class="alert-color">Maximum 30 characters.
                  </div>
                  <div *ngIf="f.inputDistrict.errors.pattern" class="alert-color">Enter valid district</div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="control-label">State</label>
                <input class="form-control" type="text" name="updatestate" formControlName="inputState"
                       autocomplete="off" [ngClass]="{ 'is-invalid': submitted && f.inputState.errors }"
                       [(ngModel)]="address.state" required/>
                <div *ngIf="submitted && f.inputState.errors" class="invalid-feedback">
                  <div *ngIf="f.inputState.errors.required" class="alert-color">State is required.</div>
                  <div *ngIf="f.inputState.errors.minlength" class="alert-color">Minimum 3 characters.</div>
                  <div *ngIf="f.inputState.errors.maxlength" class="alert-color">Maximum 50 characters.</div>
                  <div *ngIf="f.inputState.errors.pattern" class="alert-color">Enter valid landmark</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row top-field">
            <div class="col-xs-12 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="control-label">Country</label>
                <ng-autocomplete [(ngModel)]="item" name="item" [data]="countries" [searchKeyword]="keyword"
                                 placeholder="Enter the country Name" required (selected)='selectEvent($event)'
                                 formControlName="countryName"
                                 [ngClass]="{ 'is-invalid': submitted && f.countryName.errors }"
                                 (inputChanged)='onChangeSearch()' (inputFocused)='onFocused()'
                                 [itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate">
                </ng-autocomplete>
                <ng-template #itemTemplate let-item>
                  <a [innerHTML]="item.name"></a>
                </ng-template>
                <ng-template #notFoundTemplate let-notFound>
                  <div [innerHTML]="notFound"></div>
                </ng-template>
                <div *ngIf="submitted && f.countryName.errors" class="invalid-feedback">
                  <div *ngIf="f.countryName.errors.required" class="alert-color">Country is required.</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row top-field">
            <div class="col-lg-6">

            </div>
            <div class="col-lg-6">
              <button class="btn btn-info pull-right" type="submit">Submit</button>
              <button class="btn btn-info pull-right" type="button" (click)="showsiteformClick()"
                      [disabled]="!isFarmAddedtoDB" style="margin-right: 20px;">Add
                Site
              </button>
              <!--<button class="btn btn-info pull-right" style="margin-right: 20px;">Add Site</button>-->
            </div>
          </div>
        </form>
        <hr>
        <!-- site form -->
        <form *ngIf="showsiteform" [formGroup]="addFarmsiteForm" (ngSubmit)="addFarmSite()">
          <div class="row top-field">
            <div>
              <p style="font-size: 20px;">Site Details</p>
            </div>
          </div>
          <div class="row top-field">
            <div class="col-xs-12 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="control-label">Site Name</label>
                <input class="form-control" type="text" [(ngModel)]="farmSite.farmNameAtLocation"
                       formControlName="farmNameAtLocation" autocomplete="off"
                       [ngClass]="{ 'is-invalid': farmSitesubmitted && f1.farmNameAtLocation.errors }" required
                       name="sitename"/>
                <div *ngIf="farmSitesubmitted && f1.farmNameAtLocation.errors" class="invalid-feedback">
                  <div *ngIf="f1.farmNameAtLocation.errors.required" class="alert-color">Site name is required.
                  </div>
                  <div *ngIf="f1.farmNameAtLocation.errors.pattern" class="alert-color">Special characters are not
                    allowed.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="control-label">Ownership</label>
                <select name="Ownership" class="form-control select" [(ngModel)]="farmSite.ownership"
                        formControlName="ownership">
                  <option value="undefined" disabled selected>Select Ownership</option>
                  <option value="Owned">Owned</option>
                  <option value="Leased">Leased</option>
                </select>
                <span class="caret history-caret"></span>
              </div>
            </div>
          </div>
          <!-- FarmSite Address -->
          <div class="row top-field">
            <div class="col-md-6">
              <div class="form-group">
                <label>State</label>
                <ng-autocomplete [(ngModel)]="stateitem" name="state" [data]="filteredStates" [searchKeyword]="statekeyword"
                                placeholder="Enter the state name" required (selected)='stateSelectEvent($event)'
                                formControlName="State" (inputCleared)="stateOnCleared()" [disabled]="stateVillageDisabled"
                                [ngClass]="{ 'is-invalid': farmSitesubmitted && f1.State.errors }"
                                (inputChanged)='statOnChangeSearch($event)' (inputFocused)='stateOnFocused($event)'
                                [itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate">
                </ng-autocomplete>
                <ng-template #itemTemplate let-item><a [innerHTML]="item.name"></a></ng-template>
                <ng-template #notFoundTemplate let-notFound>
                  <div [innerHTML]="notFound"></div>
                </ng-template>
                <div *ngIf="farmSitesubmitted && f1.State.errors" class="invalid-feedback">
                  <div *ngIf="f1.State.errors.required" class="alert-color">State is required.</div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Village/Town/City/Mandal</label>
                <ng-autocomplete [(ngModel)]="villageItem" name="village" [data]="filteredVillages" [searchKeyword]="villagekeyword"
                             placeholder="Enter the village/Taluk/Mandal/District name" required (selected)='villageSelectEvent($event)'
                             formControlName="village" (keyup)="villageSearchEvent(villageItem,$event)"
                             [ngClass]="{ 'is-invalid': farmSitesubmitted && f1.village.errors }"
                             (inputCleared)="villageOnCleared()" [disabled]="stateVillageDisabled"
                             (inputChanged)='villageOnChangeSearch($event)' (inputFocused)='villageOnFocused($event)'
                             [itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate">
                </ng-autocomplete>
                <ng-template #itemTemplate let-item><a [innerHTML]="item.name"></a></ng-template>
                <ng-template #notFoundTemplate let-notFound>
                  <div [innerHTML]="notFound"></div>
                </ng-template>
                <div *ngIf="farmSitesubmitted && f1.village.errors" class="invalid-feedback">
                  <div *ngIf="f1.village.errors.required" class="alert-color">Village is required.</div>
                </div>
              </div>
            </div>
          </div>
          <!-- FarmSite Address End -->

          <div class="row top-field">
            <div>
              <p style="font-size: 20px;">Other Details</p>
            </div>
          </div>
          <div class="row top-field">
            <div class="col-xs-12 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="control-label">Year Started</label>
                <select formControlName="yearStarted" autocomplete="off"
                        class="form-control select" [ngClass]="{ 'is-invalid': farmSitesubmitted && f1.yearStarted.errors }"
                        [(ngModel)]="farmSite.yearStarted" name="yearstarted">
                  <option value="undefined" disabled selected>Select Year</option>
                  <option *ngFor="let year of yearStartedArr" value="{{year}}">{{year}}</option>
                </select>
                <span class="postoffice_caret caret"></span>
                <div *ngIf="farmSitesubmitted && f1.yearStarted.errors" class="invalid-feedback">
                  <div *ngIf="f1.yearStarted.errors.required" class="alert-color">Year started is required.</div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="control-label">Area(ha)</label>
                <input class="form-control" type="text" [(ngModel)]="farmSite.totalFarmArea" formControlName="totalFarmArea"
                       autocomplete="off"
                       name="area"/>
              </div>
            </div>
          </div>
          <div class="row top-field">
            <div class="col-xs-12 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="control-label">No. of Grow Out Ponds</label>
                <input class="form-control" type="text" [(ngModel)]="farmSite.numberOfGrowoutPonds"
                       formControlName="numberOfGrowoutPonds" autocomplete="off"
                       name="noofgrowoutponds"/>
              </div>
            </div>
            <div class="col-xs-12 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="control-label">Water Spread Area(ha)</label>
                <input class="form-control" type="text" [(ngModel)]="farmSite.waterSpreadArea"
                       (change)="changewaterspreadare()"
                       formControlName="waterSpreadArea" autocomplete="off"
                       name="waterspreadarea"/>
                <span *ngIf="waterareavalidation"
                      style="color: red">water spread area is lessthan Area.</span>
              </div>
            </div>
          </div>
          <div class="row top-field">
            <div class="col-xs-12 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="control-label">No. of Nurseries</label>
                <input class="form-control" type="text" [(ngModel)]="farmSite.numberOfNurseries" autocomplete="off"
                       formControlName="numberOfNurseries"
                       name="noofnurseries"/>
              </div>
            </div>
            <div class="col-xs-12 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="control-label">Water Type</label>
                <select type="text" class="form-control" [(ngModel)]="waterType.waterTypeId" name="watertype"
                        formControlName="waterTypeId"
                        [ngClass]="{ 'is-invalid': farmSitesubmitted && f1.waterTypeId.errors }"
                        required>
                  <option value=undefined disabled selected>Select Water Type</option>
                  <option value="{{waterType.id}}"
                          *ngFor="let waterType of waterTypes">{{waterType.name}}</option>
                </select>
                <span class="history-caret caret"></span>
                <div *ngIf="farmSitesubmitted && f1.waterTypeId.errors" class="invalid-feedback">
                  <div *ngIf="f1.waterTypeId.errors.required" class="alert-color">Watertype is required.</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row top-field">
            <div class="col-xs-12 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="control-label">Soil Type</label>
                <select type="text" class="form-control" [(ngModel)]="soilType.soilTypeId" name="soiltype" required
                        formControlName="soilTypeId" [ngClass]="{ 'is-invalid': farmSitesubmitted && f1.soilTypeId.errors }">
                  <option value=undefined disabled selected>Select Soil Type</option>
                  <option value="{{soilType.id}}" *ngFor="let soilType of soilTypes">{{soilType.name}}</option>
                </select>
                <span class="history-caret caret"></span>
                <div *ngIf="farmSitesubmitted && f1.soilTypeId.errors" class="invalid-feedback">
                  <div *ngIf="f1.soilTypeId.errors.required" class="alert-color">Watertype is required.</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row top-field">
            <div class="col-xs-12 col-md-6 col-sm-6">
              <div style="margin-bottom: 20px;">
                <p style="font-size: 20px;">Bio-Security Details</p>
              </div>
              <div class="row top-field">
                <label class="control-label business_details_label">Bio-Security in the Farm</label>
                <div>
                  <label class="checkbox-inline col-xs-4">
                    <input type="checkbox" value="" name="fencing" [(ngModel)]="bioFencing"
                           formControlName="bioFencing">Fencing
                  </label>
                  <label class="checkbox-inline col-xs-6">
                    <input type="checkbox" value="" name="hwandfa" [(ngModel)]="bioHWandFA"
                           formControlName="bioHWandFA">Hand Wash and Footbath
                    Area
                  </label>
                </div>
                <div>
                  <label class="checkbox-inline col-xs-4">
                    <input type="checkbox" value="" name="crab" [(ngModel)]="bioCrabFencing"
                           formControlName="bioCrabFencing">Crab Fencing
                  </label>
                  <label class="checkbox-inline col-xs-4">
                    <input type="checkbox" value="" name="reservoirs" [(ngModel)]="bioReservoirs"
                           formControlName="bioReservoirs">Reservoirs
                  </label>
                </div>
                <div>
                  <label class="checkbox-inline col-xs-4">
                    <input type="checkbox" value="" name="birdfencing" [(ngModel)]="bioBirdFencing"
                           formControlName="bioBirdFencing">Bird Fencing
                  </label>
                  <label class="checkbox-inline col-xs-4">
                    <input type="checkbox" value="" name="filters" [(ngModel)]="bioFilters"
                           formControlName="bioFilters">Filters
                  </label>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-md-6 col-sm-6">
              <div class="row top-field" style="margin-top: 18px">
                <div class="col-xs-6">
                  <!--<div class="form-group" [ngClass]="!isChecked ? 'disbledCls' : ''">-->
                  <div class="form-group">
                    <label class="control-label">Start Date</label>
                    <input class="form-control" type="date" [(ngModel)]="startDate" autocomplete="off"
                           formControlName="startDate" (change)="startdatechange()"
                           [max]="maxstartdate" [min]="minstartdate" name="noofnurseries"/>
                  </div>
                </div>
                <div class="col-xs-6">
                  <div class="form-group">
                    <label class="control-label">End Date</label>
                    <input class="form-control" type="date" [(ngModel)]="endDate" autocomplete="off"
                           formControlName="endDate" (change)="enddatechange()" [min]="minenddate"
                           name="noofnurseries"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row top-field">
            <div class="col-xs-12 col-md-6 col-sm-6">
              <p>ETS on premises</p>
              <div class="form-group">
                <label class="radio-inline">
                  <input type="radio" name="ETSOnPremises" [(ngModel)]="farmSite.ETSOnPremises" [value]="true"
                         formControlName="ETSOnPremises">Yes
                </label>
                <label class="radio-inline">
                  <input type="radio" name="ETSOnPremises" [(ngModel)]="farmSite.ETSOnPremises" [value]="false"
                         formControlName="ETSOnPremises">No
                </label>
              </div>
            </div>
          </div>
          <div class="row top-field">
            <div class="col-xs-12 col-md-6 col-sm-6">
              <p>Lab on premises</p>
              <div class="form-gLroup">
                <label class="radio-inline">
                  <input type="radio" name="labOnPremises" [(ngModel)]="farmSite.labOnPremises" [value]="true"
                         formControlName="labOnPremises">Yes
                </label>
                <label class="radio-inline">
                  <input type="radio" name="labOnPremises" [(ngModel)]="farmSite.labOnPremises" [value]="false"
                         formControlName="labOnPremises">No
                </label>
              </div>
            </div>
          </div>
          <div>
            <div class="col-lg-12">
              <button class="btn btn-info pull-right">Submit
              </button>
            </div>
          </div>
        </form>
        <!-- End farm site-->
      </div>
    </div>
  </div>
</div>
